import TownView from './Town';
import MapView from './Map';
import TrainingView from './TreasurerTrainings';
import BarredFilers from './BarredFilers';

const routes = [
  {
    path: '/Municipal/Town',
    renderer: (params = {}): JSX.Element => <TownView {...params} />,
  },
  {
    path: '/Municipal/Map',
    renderer: (params = {}): JSX.Element => <MapView {...params} />,
  },
  {
    path: '/Municipal/TreasurerTrainings',
    renderer: (params = {}): JSX.Element => <TrainingView {...params} />,
  },
  {
    path: '/Municipal/BarredFilers',
    renderer: (params = {}): JSX.Element => <BarredFilers {...params} />,
  }
];

export default routes;
